import * as types from '../types/elements'

const initalState = []

const elements = ( state = initalState, action ) => {
  const { type, payload } = action

  switch ( type ) {

  case types.SET_ELEMENTS:
    return [ ...payload ]
  
  case types.ADD_ELEMENT:
    state.push( payload )
    return [ ...state ]

  case types.UPDATE_ELEMENT:
    const items = state.map( item => {
      if( +item.id === +payload.id ) {
        const newItem = {
          ...item,
          ...payload.element
        }
        newItem.content = JSON.stringify( newItem.content )
        return newItem
      }
      return item
    } )
    return [ ...items ]
  
  case types.REMOVE_ELEMENT:
    return [ ...state.filter( item => +item.id !== +payload ) ]

  default: 
    return state
  }
}

const actualElement = ( state = null, action ) => {
  const { type, payload } = action
  switch( type ) {

  case types.SET_ACTIVE_ELEMENT:
    if( !payload ) {
      return payload
    }
    const newElement = {
      ...payload
    }
    if( typeof payload.content === 'string' ) {
      newElement.content = JSON.parse( payload.content )
    }
    return newElement

  default:
    return state
  }

}

export { elements, actualElement }


// WEBPACK FOOTER //
// ./src/store/reducers/elements.js